import { defaultStyles } from 'library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    header: {
        marginBottom: '5px'
    },
    figure: {
        margin: '0',
    },
    image: {
        width: '100%',
    },
    title: {
        marginTop: '58px',
        fontSize: '48px',
        lineHeight: '60px',
        textAlign: 'center',
        '@media screen and (min-width: 768px)': {
            textAlign: 'left',
        }
    },
    row: {
        marginBottom: '48px',
        '@media screen and (min-width: 768px)': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    },
    stretchCol: {
        backgroundColor: defaultStyles.greyWhite,
        padding: '5px 20px',
        '@media screen and (min-width: 768px)': {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 'auto',
        }
    },
    staticCol: {
        padding: '20px 0',
        '@media screen and (min-width: 768px)': {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: '220px',
        }
    },
    description: {
        marginTop: '15px',
        marginBottom: '15px',
    }
});

export default styles;
